import React, { useState, useEffect } from "react";

import "./Styles/GroupForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function UpdateClassForm(props) {
  const [object, setObject] = useState({
    name: props.object.name,
    id: props.object.id,
  });
  const [loading, setLoading] = useState(false);
  const [showBoxOfVarietiesList, setshowBoxOfVarietiesList] = useState(false);
  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [dataOFVarieties, setdataOFVarieties] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;

  //get data of varieties Carrier ....
  const getDataOfVarietiesCarrier = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/VarietiesCarrier/show",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setdataOFVarieties(data.data.data);
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };
  useEffect(() => {
    setObject(props.object);
    getDataOfVarietiesCarrier(ApiSettings.apiUrl);
  }, [props.object]);

  //here we will sent request with data to save it in our database.
  const sentFormData = async () => {
    if (!object.name) {
      //   alert("أسم المهنة مطلوب");
      setsnackBar({
        ...snackBar,
        message: "أسم المهنة مطلوب",
        severity: "warning",
        open: true,
      });
      return;
    }
    setLoading(true);

    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ApiSettings.apiUrl + "/VarietiesCarrier/insert",
        data: {
          name: object.name,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (data) {
        if (data.data.status == 200) {
          setLoading(false);
          setdataOFVarieties((item) => [...item, data.data.data]);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${
        props.inactive === false ? "activeSideMenu" : ""
      }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">تعد يل مهنة</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12 align-items-center  d-flex">
            <div
              className="form-outline formInput"
              style={{ position: "relative" }}
            >
              <label
                // className="form-label"
                htmlFor="lableforTypeOFActivity"
                className="lableforTypeOFActivity"
              >
                أسم المهنة
              </label>
              <input
                type="text"
                id="lableforTypeOFActivity"
                className="TypeOFActivity"
                placeholder="أسم المهنة..."
                value={object.name}
                onChange={(e) => {
                  setObject({
                    ...object,
                    name: object.name,
                  });
                }}
                onClick={() => {
                  setshowBoxOfVarietiesList(!showBoxOfVarietiesList);
                }}
              />
              {showBoxOfVarietiesList ? (
                <div className="dropdownlistselected">
                  {dataOFVarieties.length > 0 ? (
                    dataOFVarieties.map((data) => (
                      <span className="itemOfList">{data.name}</span>
                    ))
                  ) : (
                    <span className="px-3">لاتوجد بيانات</span>
                  )}
                </div>
              ) : null}
            </div>

            <div className="d-flex align-items-center mt-3">
              <Button
                variant="contained"
                className="mx-3 section1CarrerName section1Button mt-4 pt-1"
                onClick={() => {
                  sentFormData();
                }}
              >
                {!loading ? (
                  "تعديل"
                ) : (
                  <div className="spinner-border " role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
